import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Log in ")
const _hoisted_2 = {
  key: 1,
  class: "flex items-center ml-auto"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Log out ")

import { PropType } from 'vue';
import ButtonComponent from './ButtonComponent.vue';
import { User } from '@/models/User';
import { useGlobalStore } from '@/store/globalStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginButtonComponent',
  props: {
  isLoggedIn: Boolean,
  isEmailVerified: Boolean,
  currentUser: Object as PropType<User | null>
},
  setup(__props) {



const logout = () => {
  useGlobalStore().logout();
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!__props.isLoggedIn)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          class: "flex items-center ml-auto text-2xl font-semibold",
          to: { name: 'login' },
          "data-testid": "login-link"
        }, {
          default: _withCtx(() => [
            _createVNode(ButtonComponent, { class: "flex items-center p-4 py-2 text-sm rounded focus:outline-none whitespace-nowrap" }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(ButtonComponent, {
            class: "flex items-center p-4 py-2 text-sm rounded focus:outline-none whitespace-nowrap",
            onClick: logout,
            "data-testid": "logout-button",
            "color-type": "tertiary"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]))
  ]))
}
}

})